var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.alldata.nav.current.text==='English')?_c('Enhome'):_c('Zhhome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }